import { Trans, t } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { Stack, Paper, Box, Typography } from '@mui/material'
import { Dayjs } from 'dayjs'
import FilterAltRoundedIcon from '@mui/icons-material/FilterAltRounded'

import DatePickerInput from '@/components/ui/inputs/DatePickerInput'

type SessionsFilterProps = {
  from: Dayjs
  to: Dayjs
  onFromChange: (date: Dayjs) => void
  onToChange: (date: Dayjs) => void
}

export function SessionsFilter({ from, to, onFromChange, onToChange }: SessionsFilterProps) {
  useLingui()

  return (
    <Paper
      elevation={0}
      sx={{
        border: '1px solid',
        borderColor: 'grey.200',
        borderRadius: 2,
        overflow: 'hidden',
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        sx={{
          px: 3,
          py: 1.5,
          borderBottom: '1px solid',
          borderColor: 'grey.100',
          bgcolor: 'grey.50',
        }}
      >
        <FilterAltRoundedIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
        <Typography variant="subtitle2" sx={{ color: 'text.secondary', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>
          <Trans>Filters</Trans>
        </Typography>
      </Stack>
      <Box sx={{ p: 3 }}>
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} alignItems={{ xs: 'stretch', md: 'flex-end' }}>
          <Box sx={{ width: { xs: '100%', md: 200 } }}>
            <DatePickerInput label={t`From`} value={from} onChange={(date) => date && onFromChange(date)} fullWidth />
          </Box>
          <Box sx={{ width: { xs: '100%', md: 200 } }}>
            <DatePickerInput label={t`To`} value={to} onChange={(date) => date && onToChange(date)} fullWidth />
          </Box>
        </Stack>
      </Box>
    </Paper>
  )
}
